import createAxiosInstance from "../LambdaApiAdministracion";
import { ENVIROMENT } from "../../utilities";

export async function GetFetchSucursales(useFIESTATUS, brandId = null) {
  const axiosInstance = await createAxiosInstance();
  // TODO adicionar url de produccion real
  const baseUrl = ENVIROMENT === "dev" ? `/admon/sucursal` : `/home/admon/sucursal`;
  let url = useFIESTATUS ? `${baseUrl}?FIESTATUSID=1` : baseUrl;

  if (brandId !== null) {
    if (useFIESTATUS) {
      url = `${url}&brandId=${brandId}`;
    } else {
      url = `${url}?brandId=${brandId}`;
    }
  }

  const requestConfig = {
    method: "GET", // Cambia el método si es necesario
    url: url,
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Realizar la solicitud Axios usando la instancia personalizada
  return axiosInstance(requestConfig);
}
